import { Dropdown } from "primereact/dropdown"
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface IDropdown {
    label?: string,
    name: string,
    defaultValue?: any,
    control: any,
    error?: string
    options: any
    optionValue: string,
    optionLabel: string,
    placeholder?: string,
    required?: boolean,
    column?: number,
    disabled?: boolean,
    filter?: true,
    itemTemplate?: (option: any, props?: any) => JSX.Element,
    valueTemplate?: (option: any) => JSX.Element
    optionDisabled?: (option: any) => boolean;

}

export const JVDropdown = (props: IDropdown) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}
            <Controller name={props.name} control={props.control} defaultValue={props.defaultValue} render={({ field, fieldState }) => (
                <Dropdown inputId={field.name} disabled={props.disabled} {...field} options={props.options} optionValue={props.optionValue} optionLabel={props.optionLabel} value={field.value} placeholder={props.placeholder} className={classNames({ 'p-invalid': fieldState.invalid })} filter={props?.filter === true ? true : false} itemTemplate={props?.itemTemplate ? props?.itemTemplate : null}
                    valueTemplate={props?.valueTemplate ? props?.valueTemplate : null} style={{ height: "34px" }} />
            )} />
            <small className="p-error" >{props.error}</small>
        </div>
    )
}